export interface DeviceResolution {
    width: number;
    height: number;
}

export interface PreviewDevice {
    /** SVG to load as a frame */
    frameSource: 'mobile' | 'desktop';
    /** Size of the frame image */
    frameSize: DeviceResolution;
    /** Position of the screen in the frame */
    frameScreenPosition: {
        x: number;
        y: number;
        borderBottomLeftRadius: number;
        borderBottomRightRadius: number;
    };
    /** Size of the screen in the frame */
    frameScreenSize: DeviceResolution;
    /** Resolution of the screen to emulate */
    screenResolution: DeviceResolution;
}

export const mobile: PreviewDevice = {
    frameSource: 'mobile',
    frameSize: {
        width: 332,
        height: 640,
    },
    frameScreenPosition: {
        x: 21,
        y: 100,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
    },
    ...createScreenSize(
        {
            width: 290,
            height: 516,
        },
        360
    ),
};

export const desktop: PreviewDevice = {
    frameSource: 'desktop',
    frameSize: {
        width: 937,
        height: 616,
    },
    frameScreenPosition: {
        x: 13,
        y: 83,
        borderBottomLeftRadius: 7,
        borderBottomRightRadius: 7,
    },
    ...createScreenSize(
        {
            width: 911,
            height: 518,
        },
        1440
    ),
};

function createScreenSize(
    frameScreenSize: DeviceResolution,
    resolutionWidth: number
): Pick<PreviewDevice, 'frameScreenSize' | 'screenResolution'> {
    return {
        frameScreenSize,
        screenResolution: {
            width: resolutionWidth,
            height: Math.round((resolutionWidth * frameScreenSize.height) / frameScreenSize.width),
        },
    };
}

export * from './DesktopFrame';
export * from './MobileFrame';
